// extracted by mini-css-extract-plugin
export var btnClose = "Notification-module--btnClose--fb532";
export var content = "Notification-module--content--272e4";
export var eventDot = "Notification-module--eventDot--ef399";
export var hideOnMobile = "Notification-module--hideOnMobile--9900a";
export var highlight = "Notification-module--highlight--fdecc";
export var link = "Notification-module--link--9e3dc";
export var root = "Notification-module--root--c91b8";
export var wrapper = "Notification-module--wrapper--5c1a2";